export default "__VITE_ASSET__D1llml1j__"